<template>
  <v-list class="py-0">
    <template v-for="item in getItems">
      <v-list-item :class="['px-0', { 'primary lighten-4': item.status === 'registered' }]" :key="item.id">
        <v-row>
          <v-col :class="['text-center text-truncate', { caption: $vuetify.breakpoint.mdAndDown }]">{{ item.date }}</v-col>
          <v-col :class="['text-right text-truncate', { caption: $vuetify.breakpoint.mdAndDown }]">{{ item.payee }}</v-col>
          <v-col :class="['text-right text-truncate', { caption: $vuetify.breakpoint.mdAndDown }]">{{ item.client }}</v-col>
          <v-col :class="['text-right text-truncate', { caption: $vuetify.breakpoint.mdAndDown }]">{{ item.item }}</v-col>
          <v-col :class="['text-center text-truncate', { caption: $vuetify.breakpoint.mdAndDown }]">{{ item.sum }}</v-col>
          <v-col :class="['text-center text-truncate', { caption: $vuetify.breakpoint.mdAndDown }]">{{ item.content }}</v-col>
        </v-row>
      </v-list-item>
      <v-divider :key="`${item.id}_div`"></v-divider>
    </template>
  </v-list>
</template>

<script>
export default {
  name: 'authorBbookPreviewDc',
  props: [ 'items' ],
  computed: {
    getItems () {
      return (this.$props.items && this.$props.items.length) ? this.$props.items.map(it => {
        return {
          id: it.id,
          date: this.$moment(it.date).format('YYYY/MM/DD'),
          payee: it.payee,
          client: it.client,
          item: it.item,
          sum: `${it.sum}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,'),
          content: it.content,
          status: it.status
        }
      }) : []
    }
  }
}
</script>